import * as higherOrderNamespace from './higher-order';
import * as layoutsNamespace from './layouts';
import * as pagesNamespace from './pages';
import * as partialsNamespace from './partials';
import * as proxyNamespace from './proxy';

export const higherOrder = higherOrderNamespace;
export const layouts = layoutsNamespace;
export const pages = pagesNamespace;
export const partials = partialsNamespace;
export const proxy = proxyNamespace;

const components = {
  higherOrder,
  layouts,
  pages,
  partials,
  proxy
}

export default components;



// WEBPACK FOOTER //
// ./src/components/index.js